import InputStep from '../steps/InputStep';
import CivilityStep from '../steps/CivilityStep';
import DateStep from '../steps/DateStep';
import PhoneStep from '../steps/PhoneStep';
import StoreSearchStep from '../steps/StoreSearchStep';
import ErrorMessage from './ErrorMessage';

const ERROR_INPUT_CLASSES = 'border-red-300 shadow-[0px_6px_0px_0px_#FCA5A5]';

const stepConfigurations = [
  {
    field: 'fullName',
    placeholder: 'Nom et prénom',
    component: InputStep
  },
  {
    field: 'civility',
    component: CivilityStep
  },
  {
    field: 'birthDate',
    component: DateStep
  },
  {
    field: 'email',
    placeholder: 'Email',
    type: 'email',
    component: InputStep
  },
  {
    field: 'phone',
    component: PhoneStep
  },
  {
    field: 'store',
    component: StoreSearchStep
  }
];

const createInputWithError = (config, props, error) => {
  const { component: Component, field, placeholder, type } = config;

  return (
    <div className="flex flex-col">
      <Component
        value={props.formData[field]}
        onChange={(value) => props.handleFieldChange(field, value)}
        placeholder={placeholder}
        type={type}
        className={error ? ERROR_INPUT_CLASSES : undefined}
        emailOptin={props.formData.emailOptin}
        onEmailOptinChange={(checked) => props.handleFieldChange('emailOptin', checked)}
      />
      {error && <ErrorMessage message={error} />}
    </div>
  );
};

const createDateStep = (props) => (
  <DateStep
    value={props.formData.birthDate}
    onChange={(value) => props.handleFieldChange('birthDate', value)}
    error={props.errors.birthDate}
  />
);

const createCivilityStep = (props) => (
  <CivilityStep
    value={props.formData.civility}
    onChange={(value) => props.setFormData({ ...props.formData, civility: value })}
  />
);

const createPhoneStep = (props) => (
  <PhoneStep
    value={props.formData.phone}
    onChange={(value) => props.handleFieldChange('phone', value)}
    error={props.errors.phone}
    isPhoneValid={props.isValidPhone}
    dialCode={props.dialCode}
    setDialCode={props.setDialCode}
    smsOptin={props.formData.smsOptin}
    onSmsOptinChange={(checked) => props.handleFieldChange('smsOptin', checked)}
  />
);

const createStoreSearchStep = (props) => (
  <StoreSearchStep
    value={props.formData.store}
    onChange={(value) => props.handleFieldChange('store', value)}
    error={props.errors.store}
    companyId={props.companyId}
    onComplete={props.handleComplete}
    isButtonLoading={props.isLoading}
  />
);

const stepRenderers = [
  (props) => createInputWithError(stepConfigurations[0], props, props.errors.fullName),
  createCivilityStep,
  createDateStep,
  (props) => createInputWithError(stepConfigurations[3], props, props.errors.email),
  createPhoneStep,
  createStoreSearchStep
];

const CreationStepRenderer = (props) => {
  const { currentStepIndex } = props;

  const renderStep = stepRenderers[currentStepIndex];

  return renderStep ? renderStep(props) : null;
};

export default CreationStepRenderer;